<template>
    <div class="menu" :class="{'is-open':openToggle}">
        <button class="menu-toggle"  @click="switchToggle" >toggle menu</button>
        <div class="menu-dropdown">
            <ul @click="forcecloseToggle" class="nav-menu">
                <slot>
                </slot>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
  name: 'vueToggleMenuPcMobile',
  data () {
    return {
      openToggle: false
    }
  },
  methods: {
    switchToggle: function () {
      this.openToggle = !this.openToggle
    },
    forcecloseToggle: function () {
      this.openToggle = false
    }
  }
}
</script>

<style scoped>
    .menu {
      position: relative;
    }

    .menu .menu-toggle {
      position: absolute;
      top: -0.9em;
      right: 0.2em;
      border: 0;
      background-color: transparent;
      font-size: 3em;
      width: 1em;
      height: 0.8em;
      line-height: 0.6;
      text-indent: 5em;
      white-space: nowrap;
      overflow: hidden;
    }
    .menu .menu-toggle::after {
      position: absolute;
      top: 0.1em;
      left: 0.2em;
      display: block;
      content: "\2261";
      text-indent: 0;
    }

    .menu  .menu-dropdown {
      display: none;
      width: 50%;
      position: absolute;
      right: 0;
      margin: 0;
    }

    .menu.is-open .menu-dropdown {
      display: block;
      z-index: 4
    }

    .menu .menu-dropdown .nav-menu {
      margin: 0;
      padding-left: 0;
      border-top: 1px 0 solid #ccc;
      list-style: none;
      background-color: #000;
      color: #fff;
    }

    .menu .menu-dropdown .nav-menu > li + li {
      border-top: 1px solid #ccc;
    }

    .menu .menu-dropdown ul li  a.router-link-exact-active.router-link-active, .menu .menu-dropdown ul  li.normali  a:hover, .menu .menu-dropdown ul  li.normali  a:focus{
      background-color:#162436;
      -webkit-transition: 0.5s background-color;
      transition: 0.2s background-color
    }
</style>
